import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { t } from 'autobiz-translate';
import { useState } from 'react';
import { recordActions } from '../../config/configuration/react';

export const useGuaranteedPriceProcess = ({ recordId }) => {
  const history = useHistory();
  const [textBody, setTextBody] = useState('');
  const [newGuaranteedOpen, setNewGuaranteedOpen] = useState(false);
  const [maintainGuarantee, setMaintainGuarantee] = useState(false);
  const guaranteedPrice = useSelector((state) => state.reduxRecords.data[recordId]?.guaranteedPrice || []);

  const dispatch = useDispatch();
  const toggleNewGuarantted = (typeMethod) => {
    setNewGuaranteedOpen(!newGuaranteedOpen);
    if (typeMethod === 'noAcceptGuaranteed') {
      setTextBody(t('confirmingNotAcceptingNewTradeInPrice'));
      setMaintainGuarantee(false);
    }
    if (typeMethod === 'acceptGuaranteed') {
      setTextBody(t('clientAcceptingNewTradeInPrice'));
      setMaintainGuarantee(true);
    }
  };
  const putMaintainedGuanranteed = async (maintainedGuarantee, id) => {
    await dispatch(recordActions.putMaintainedGuanranteed(maintainedGuarantee, id));
  };

  const cancelGuaranteed = () => {
    setNewGuaranteedOpen(!newGuaranteedOpen);
  };
  const confirmGuaranteed = async (id) => {
    try {
      await putMaintainedGuanranteed(maintainGuarantee, id);
      setNewGuaranteedOpen(!newGuaranteedOpen);
      history.push(`/files/${id}`);
    } catch (e) {
      console.log(e);
    }
  };

  return { textBody, newGuaranteedOpen, toggleNewGuarantted, cancelGuaranteed, confirmGuaranteed, guaranteedPrice };
};
